import { DateTime } from "luxon";

export const US_DISPLAY_TIMEZONES = [
  { zone: "America/New_York" },
  { zone: "America/Chicago" },
  { zone: "America/Denver" },
  { zone: "America/Los_Angeles" },
  { zone: "America/Anchorage" },
  { zone: "Pacific/Honolulu" }
] as const;

export type UsDisplayTimezone = (typeof US_DISPLAY_TIMEZONES)[number]["zone"];

export const NEARBY_US_TIMEZONE_HOURS = 2;

export type UsTimezoneConversionRow = {
  zone: UsDisplayTimezone;
  abbrev: string;
  time: string;
  date: string;
  isYours: boolean;
};

export type UsTimezoneConversionRows = {
  all: UsTimezoneConversionRow[];
  nearby: UsTimezoneConversionRow[];
};

function getTimezoneOffsetMinutes(iso: string, zone: string): number | null {
  const zoned = DateTime.fromISO(iso, { setZone: true }).setZone(zone);
  return zoned.isValid ? zoned.offset : null;
}

export function buildUsTimezoneConversionRows(
  iso: string,
  userTimezone?: string | null,
  hours: number = NEARBY_US_TIMEZONE_HOURS
): UsTimezoneConversionRows {
  const parsed = DateTime.fromISO(iso, { setZone: true });
  if (!parsed.isValid) return { all: [], nearby: [] };

  const userOffset = userTimezone ? getTimezoneOffsetMinutes(iso, userTimezone) : null;
  const all: UsTimezoneConversionRow[] = [];
  const nearby: UsTimezoneConversionRow[] = [];

  for (const { zone } of US_DISPLAY_TIMEZONES) {
    const zoned = parsed.setZone(zone);
    if (!zoned.isValid) continue;

    const zoneOffset = zoned.offset;
    const row: UsTimezoneConversionRow = {
      zone,
      abbrev: zoned.toFormat("ZZZZ"),
      time: zoned.toFormat("h:mm:ss a"),
      date: zoned.toFormat("LLL dd, yyyy"),
      isYours: userOffset != null && zoneOffset === userOffset
    };

    all.push(row);

    if (userOffset == null || Math.abs(zoneOffset - userOffset) <= hours * 60) {
      nearby.push(row);
    }
  }

  return { all, nearby };
}
